import React, { useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { ImageUpload, InputRange } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import Cropper from 'react-easy-crop';
import { useImageUpload } from './useImageUpload';

export const PetProfileImageUpload = ({
  iconCssClass,
  newProfileImage,
  setNewProfileImage,
  setCroppedPetImageAreaPixels,
  setProfileFileName
}) => {
  const [isPetImageChanged, setIsPetImageChanged] = useState(false);
  const fileProfileInputRef = useRef(null);

  const onCropComplete = useCallback(
    (_, croppedAreaPixels) => {
      setCroppedPetImageAreaPixels(croppedAreaPixels);
    },
    [setCroppedPetImageAreaPixels]
  );

  const { formContext, handleImageChange, handleDrop, crop, setCrop, zoom, setZoom, validImageFiles } = useImageUpload(
    setNewProfileImage,
    setProfileFileName,
    setIsPetImageChanged
  );

  return (
    <fieldset>
      {!isPetImageChanged && (
        <div className="petProfile">
          <ImageUpload
            name="petProfileImage"
            allowMultiple={false}
            fieldFormContext={formContext}
            validation={{}}
            inputType="file"
            labelStyle="image"
            listStyle="reveal"
            imageUrl={newProfileImage}
            customChangeHandler={handleImageChange}
            iconCssClass={iconCssClass}
          />
        </div>
      )}

      {newProfileImage && isPetImageChanged && (
        <div
          className="imageEditorContainer"
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
        >
          <div className="avatarEditorContainer">
            <div className="cropper">
              <Cropper
                name="petProfileImageCropper"
                image={newProfileImage}
                crop={crop}
                zoom={zoom}
                aspect={1}
                cropShape="round"
                showGrid={false}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
              />
            </div>
            <InputRange
              name="zoomPetProfileImage"
              type="range"
              customCssClass="zoomRange"
              min="1"
              max="3"
              step="0.1"
              value={zoom}
              onChange={(e) => setZoom(Number(e.target.value))}
            />
          </div>
          <div className="changeImageButton">
            <input
              type="file"
              ref={fileProfileInputRef}
              multiple={false}
              accept={validImageFiles}
              style={{ display: 'none' }}
              onChange={handleImageChange}
            />

            <button
              type="button"
              className="button primary"
              onClick={() => fileProfileInputRef.current && fileProfileInputRef.current.click()}
            >
              Upload another image
            </button>
            <span>
              or
              <br />
              Drag and drop an image here to upload it
            </span>
          </div>
        </div>
      )}
    </fieldset>
  );
};

PetProfileImageUpload.propTypes = {
  iconCssClass: PropTypes.string,
  newProfileImage: PropTypes.string,
  setNewProfileImage: PropTypes.func,
  setCroppedPetImageAreaPixels: PropTypes.func,
  setProfileFileName: PropTypes.func
};
